import { jsx } from 'react/jsx-runtime';
import { GridContainer, Box } from '@vp/swan';
import 'react';
import { ProductsItem } from './ProductsItem.js';

const ProductsList=({items})=>{return jsx(GridContainer,{"data-cy":"product-list-container",children:jsx(Box,{className:"items-container",children:items.map(item=>jsx(Box,{"data-cy":`productlist-order-item-${item.id}`,className:"order-item",children:jsx(ProductsItem,{item:item})},`item-${item.id}`))})})};

export { ProductsList };
//# sourceMappingURL=ProductsList.js.map
